module.exports = __webpack_public_path__ + "static/vimy-oaks-logo-a310de645e9ac55bbaf8b2a1e0b9834e.png";